import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { Message, MessageCategoryEnum, MessageSeverityEnum } from '../types';

export const mockNotifications: Message[] = [
  {
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    category: MessageCategoryEnum.Event,
    createdAt: '2024.03.12. 16:09:48',
    id: 21,
    isRead: false,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 22,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 23,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 31,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Info,
  },
  {
    id: 32,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Info,
  },
  {
    id: 33,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Info,
  },
  {
    id: 1,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: true,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Error,
  },
  {
    id: 2,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Error,
  },
  {
    id: 3,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Error,
  },
  {
    id: 4,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Info,
  },
  {
    id: 5,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 6,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: true,
    category: MessageCategoryEnum.Promotion,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 7,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: true,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 8,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 9,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Event,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 10,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Promotion,
    severity: MessageSeverityEnum.Success,
  },
  {
    id: 11,
    createdAt: '2024.03.12. 16:09:48',
    body: 'OTP limit vétel 10 db @ 17010 HUF',
    isRead: false,
    category: MessageCategoryEnum.Promotion,
    severity: MessageSeverityEnum.Info,
  },
];

export const initMockedNotificationResource = (axiosInstance: AxiosInstance) => {
  var mock = new MockAdapter(axiosInstance, { onNoMatch: 'passthrough', delayResponse: 100 });

  mock
    .onGet(new RegExp('https://wso2test.ebihnettest.ersteinv.hu:9443/notificationService/v1/messages'))
    .reply(200, mockNotifications);
};
